/**
 * Frase SIMBÓLICA das secretas (fundador, 06/10/2026; BACKLOG §13).
 *
 * Quem não é o dono — o visitante do perfil, o card que vai para o Instagram,
 * o feed — lê ESTA frase, nunca a receita da `description`: secreta revelada
 * ao público deixa de ser easter egg. O dono lê a frase e, embaixo, "Como você
 * ganhou" (`badgeHowEarned`), porque é saber o motivo que faz procurar a próxima.
 *
 * Citação só de obra em domínio público, em tradução nossa; livro com direitos
 * fica com alusão até a consulta jurídica (BACKLOG §9). Nunca spoiler, nunca
 * "você".
 *
 * ⚠️ ESPELHO de `functions/src/shared/badgeLore.ts` (o servidor grava a frase
 * no evento de feed) — travado por `tests/unit/badgeLoreParity.test.ts`.
 */
export const BADGE_LORE: Readonly<Record<string, string>> = {
  sexta_treze: "Gato preto cruzou o caminho. A página virou mesmo assim.",
  dia_do_livro: "Comemorou do único jeito que faz sentido.",
  virada_literaria: "Os fogos lá fora, a página aqui dentro.",
  guia_mochileiro: "Sabe exatamente onde deixou a toalha.",
  pequeno_principe: "“Tu te tornas eternamente responsável por aquilo que cativas.”",
  dom_casmurro: "“Olhos de cigana oblíqua e dissimulada.”",
  bip: "Bip. Mais um pra casa.",
  fenix: "Sumiu um tempo. Voltou das cinzas com um livro na mão.",
  sem_ressaca: "Ressaca literária é coisa que nunca teve.",
  tsundoku: "積ん読 — a pilha do quero-ler virou paisagem.",
  livro_secreto_mes: "Seguiu a pista e achou a chave.",
  madrugador: "A casa dormia. O capítulo, não.",
  zona_conforto: "Voltou pra um lugar onde já foi feliz.",
  // Secretas mensais (06/10, BACKLOG §13).
  primeira_pessoa: "Aprendeu a desconfiar de quem escreve em primeira pessoa.",
  hipotese_confirmada: "Entrou no laboratório pela ciência. Saiu pelo romance.",
  laboratorio_hazelwood: "Já sabe que todo laboratório esconde um romance.",
  comeco_e_fim: "Algumas coisas precisam acabar pra outras começarem.",
  reserva_confirmada: "Aceitou o convite. Não pergunte o cardápio.",
  alem_da_muralha: "Atravessou a muralha e não quis mais voltar.",
  sobrevivente_parapeito: "Atravessou o parapeito e nem olhou para baixo.",
  setimo_marido: "Sabe que a história verdadeira nunca é a da revista.",
  meia_noite: "Abriu um livro para cada vida que poderia ter tido.",
  nao_confie: "Desconfia de quem sorri demais na entrevista de emprego.",
  semideus: "Ganhou o direito de culpar os deuses pelos próprios problemas.",
  sonhador: "“Um minuto inteiro de felicidade!”",
  defunto_autor: "“Ao verme que primeiro roeu as frias carnes do meu cadáver…”",
  bloco_eu_sozinho: "Enquanto o bloco passava, ficou com o capítulo.",
  baleia: "“Na planície avermelhada os juazeiros alargavam duas manchas verdes.”",
  pirlimpimpim: "Uma pitada de pó e pronto, outro mundo.",
  grande_irmao: "“Guerra é paz. Liberdade é escravidão. Ignorância é força.”",
  anarrie: "Saiu da fogueira direto pro capítulo.",
  tinta_na_mao: "No dia de quem escreve, escreveu também.",
  moinhos: "Viu gigantes onde os outros viam moinhos.",
  livro_secreto_2026_11: "Seguiu a pista e achou a chave.",
  livro_secreto_2026_12: "Seguiu a pista e achou a chave.",
  livro_secreto_2027_01: "Seguiu a pista e achou a chave.",
  livro_secreto_2027_02: "Seguiu a pista e achou a chave.",
  livro_secreto_2027_03: "Seguiu a pista e achou a chave.",
  livro_secreto_2027_04: "Seguiu a pista e achou a chave.",
  livro_secreto_2027_05: "Seguiu a pista e achou a chave.",
  livro_secreto_2027_06: "Seguiu a pista e achou a chave.",
  livro_secreto_2027_07: "Seguiu a pista e achou a chave.",
  livro_secreto_2027_08: "Seguiu a pista e achou a chave.",
  livro_secreto_2027_09: "Seguiu a pista e achou a chave.",
  livro_secreto_2027_10: "Seguiu a pista e achou a chave.",
};
